@if(showMasterSearch) {
    <div class="containerMaster">
      <div class="content">
        @if (!isMobileDevice) {
        <div class="d-flex align-item-center">
          @for( rout of permissionTab; track rout){

            <ul class="linlTabList">
              <li
                class="linkTabs"
                [routerLink]="[rout.webRoute]"
                [routerLinkActive]="['linkTabactive']"
              >
              {{ rout.labelName }}
              </li>
            </ul>
          }

        </div>
        } @else {
          <div class="dp-chip-container">
            @for( rout of permissionTab; track rout){
            <div
              class="dp-chip"
              [routerLink]="[rout.webRoute]"
              [routerLinkActive]="['selected']"
            >
              {{ rout.labelName }}
            </div>
          }
          </div>
        }

        <div class="routerBody">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  }
@else if(isBreadCrumbPresent){
  <div class="dp-chip-container">
    @for( rout of permissionTab; track rout){
    <div
      class="dp-chip"
      [routerLink]="shouldNavigate(rout) ? [rout.webRoute] : undefined"
      [ngClass]="{'selected': !shouldNavigate(rout)}"
    >
      {{ rout.labelName }}
    </div>
  }
  </div>
  }
 @else {
  <div class="dp-chip-container">
    @for( rout of permissionTab; track rout){
    <div
      class="dp-chip"
      [routerLink]="['/', urlRouteParams[1], rout.webRoute]"
      [routerLinkActive]="['selected']"
    >
      {{ rout.labelName }}
    </div>
  }
  </div>
 }
